import React from "react";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";
import FormHelperText from "@material-ui/core/FormHelperText";

import LabelFormElement from "../../../../../formElement/LabelFormElement";
import SliderFormElementV2 from "../../../../../formElement/SliderFormElementV2";
import {isRequiredQuestion} from "../../../../../../../../utils";

import useStyles from "./styles";


const OPTIONS = [0, 20, 40, 60, 80, 100];

const STEP = 100 / (OPTIONS.length - 1);

const MARKS = OPTIONS.map((option, index) => {
  return {
    value: STEP * index,
    label: option
  };
});

const PercentProductCardV2 = ({question, onAnswerChange}) => {

  const classes = useStyles();

  const handleChange = (newValue) => {
    question.error = null; // clean error
    onAnswerChange(question.uid, newValue);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <LabelFormElement
          required={isRequiredQuestion(question)}
          label={question.question_text}
          customClasses={{labelRoot: classes.title}}
        />
        {question.error && (
          <FormHelperText
            error={true}
            classes={{
              error: classes.errorContainer
            }}>{question.error}</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} style={{marginTop: 48, marginLeft: 8, marginRight: 16, height: 90, position: 'relative'}}>
        <SliderFormElementV2
          min={0}
          max={100}
          step={1}
          marks={MARKS}
          label={!_.isNil(question.answer) ? `${question.answer} %` : undefined}
          value={question.answer}
          onChange={handleChange}
          classes={{root: classes.slider}}
        />
      </Grid>
    </Grid>
  );
};

export default PercentProductCardV2;